// Import dependencies
import React from 'react';
import LoginBox from '../../../reusables/login';
import cookie from 'js-cookie';


class AdminLoginPage extends React.Component {

    componentDidMount = () => {
        // As the component mounts, check if a token is already stored in the cookie
        var token = cookie.get('token');
        var user_type = cookie.get('user-type');
        if (token) {
            if (user_type === 'admin') {
                window.location.href = '/admin/history';
            } else if (user_type === 'member') {
                window.location.href = '/videos';
            }
        }
    }

    render() {
        return (
            <div>
                <h1 className='pageTitle'>Admin Login Page</h1>
                <LoginBox type='admin' />
            </div>
        )
    }
}

export default AdminLoginPage;